import { PropsWithClassName } from '@boltenergy-be/design-system'
import classNames from 'classnames'

const LogoWithContainer = ({ className }: PropsWithClassName) => {
  return (
    <svg
      width="100"
      height="40"
      viewBox="0 0 100 40"
      fill="none"
      className={classNames(className)}
      xmlns="http://www.w3.org/2000/svg"
      aria-describedby="logo-title"
      role="img"
    >
      <title id="logo-title">Bolt Logo</title>
      <path
        d="M43.1133 7.21484C36.0985 7.21484 31.1562 12.002 31.1562 18.8466C31.1562 25.6911 36.0985 30.3596 43.1133 30.3596C50.1281 30.3596 55.0703 25.6119 55.0703 18.8466C55.0703 12.0812 50.1281 7.21484 43.1133 7.21484ZM43.1133 24.5833C39.6458 24.5833 37.2145 22.2095 37.2145 18.8466C37.2145 15.4836 39.6458 13.0307 43.1133 13.0307C46.5808 13.0307 48.9723 15.4441 48.9723 18.8466C48.9723 22.249 46.541 24.5833 43.1133 24.5833Z"
        fill="currentColor"
      />
      <path d="M56.0195 30.0079H62.356L62.3639 1.32422H56.0195V30.0079Z" fill="currentColor" />
      <path
        d="M75.4266 23.0952C72.8359 24.9943 69.7669 24.836 69.7669 21.8687V15.3249H75.02V10.063H69.7669V4.16797H63.4297L63.4695 20.2704C63.4297 20.2704 63.4695 22.5651 63.4695 22.5651C63.4695 27.6688 66.3604 30.3591 70.6836 30.3591C70.6836 30.3591 74.8686 30.4382 77.4194 27.9853L75.4266 23.0952Z"
        fill="currentColor"
      />
      <path
        d="M27.3673 12.9302C25.4721 11.0489 22.9595 10.0041 20.2827 9.9823C20.2823 9.9823 20.2819 9.9823 20.2811 9.9823C20.2811 9.98191 20.2811 9.98151 20.2811 9.98112C20.2588 7.32442 19.2062 4.82953 17.3114 2.94868C15.3963 1.04725 12.8498 0 10.1408 0C7.4317 0 4.88565 1.04725 2.97013 2.94828C1.05501 4.84971 0 7.37743 0 10.0662V30.1143H20.1966C22.9053 30.1143 25.4522 29.067 27.3673 27.166C29.2828 25.2646 30.3374 22.7368 30.3374 20.0481C30.3374 17.3593 29.2824 14.8312 27.3673 12.9302ZM20.1966 24.0587H6.10088V10.0662C6.10088 7.85497 7.91317 6.05601 10.1408 6.05601C12.3684 6.05601 14.1946 7.63539 14.1946 10.4551C12.537 10.8112 11.132 11.3469 10.0124 12.0511C8.04111 13.2914 6.93668 15.0979 6.89084 17.1504C6.86693 17.5231 6.87251 18.0533 6.99487 18.6665C7.20611 19.7225 7.70193 20.6898 8.42972 21.4637C10.1045 23.246 12.2317 23.3212 13.0495 23.2741C15.1213 23.2318 16.9451 22.1351 18.1966 20.1751C18.9061 19.0637 19.4461 17.6774 19.8045 16.0316C22.7327 16.0316 24.2365 17.8365 24.2365 20.0477C24.2365 22.2589 22.4242 24.0579 20.1966 24.0579V24.0587ZM14.2811 15.8472C14.0986 16.4783 13.8506 16.9376 13.6641 17.2327C13.4369 17.592 13.2703 17.7542 13.0427 17.8246C12.9933 17.8396 12.6525 17.9449 12.4214 17.7483L12.3664 17.6937C12.1683 17.4646 12.2743 17.1259 12.2894 17.0769C12.3604 16.8509 12.5238 16.6856 12.8857 16.4601C13.183 16.2745 13.6458 16.0288 14.2815 15.8476L14.2811 15.8472Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default LogoWithContainer
